import { Component, Prop, Vue } from 'vue-property-decorator';
import WithRender from './RejectReasonMultiSelect.html';
import { RejectionReasonModel } from './RejectionReasonModel';
import {
    allRejectionReasonsSelected,
    isOtherRejectionReasonSelected,
    toggleAllRejectionReasons,
} from './rejectionReasonSelection';

@WithRender
@Component
export default class RejectReasonMultiSelect extends Vue {
    @Prop({ default: function defaultItems() { return []; } })
    public items!: RejectionReasonModel[];

    @Prop({ default: function defaultValue() { return []; } })
    public value!: RejectionReasonModel[];

    @Prop({ default: '' })
    public otherText!: string;

    @Prop({ type: Boolean, default: false })
    public disabled!: boolean;

    public get otherSelected(): boolean {
        return isOtherRejectionReasonSelected(this.value);
    }

    public get allSelected(): boolean {
        return allRejectionReasonsSelected(this.value, this.items);
    }

    public get selectAllIcon(): string {
        return this.allSelected ? 'check_box' : 'check_box_outline_blank';
    }

    public onSelected(value: RejectionReasonModel[]) {
        this.$emit('input', value ? value : []);
    }

    public onOtherInput(value: string) {
        this.$emit('other-text', typeof value === 'string' ? value : '');
    }

    public toggleSelectAll() {
        if (this.disabled) {
            return;
        }
        const current = this.value ? this.value : [];
        const items = this.items ? this.items : [];
        this.$emit('input', toggleAllRejectionReasons(current, items));
    }
}
